import { API_BASE_URL } from "../config/api";
import { appendAuthToken } from "./auth";
const withPdfCacheBust = (path, download = false) => {
  const params = new URLSearchParams();
  if (download) params.set("download", "1");
  params.set("t", String(Date.now()));
  return `${API_BASE_URL}${path}?${params.toString()}`;
};

export const getReportPdfUrl = (id, download = false) =>
  withPdfCacheBust(`/api/visits/${encodeURIComponent(id)}/pdf`, download);

export const getProductLabelsPdfUrl = (id, download = false) =>
  withPdfCacheBust(`/api/visits/${encodeURIComponent(id)}/product-labels/pdf`, download);

const isMobileDevice = () => {
  if (typeof window === "undefined") return false;

  const coarsePointer = typeof window.matchMedia === "function"
    ? window.matchMedia("(pointer: coarse)").matches
    : false;
  const narrowViewport = typeof window.innerWidth === "number" && window.innerWidth <= 768;
  const userAgent = typeof navigator !== "undefined"
    ? /android|iphone|ipad|ipod|mobile/i.test(navigator.userAgent || "")
    : false;

  return coarsePointer || narrowViewport || userAgent;
};

export const openReportPdf = (id, { download = false } = {}) => {
  const url = getReportPdfUrl(id, download);

  if (typeof window === "undefined") {
    return;
  }

  // Mobile or explicit download: trigger browser download / in-place navigation
  if (download || isMobileDevice()) {
    window.location.assign(appendAuthToken(url));
    return;
  }

  const openedWindow = window.open(appendAuthToken(url), "_blank", "noopener,noreferrer");
  if (!openedWindow) {
    window.location.assign(appendAuthToken(url));
  }
};

export const downloadReportPdf = async (id) => {
  try {
    const url = getReportPdfUrl(id, true);
    const token = typeof localStorage !== "undefined" ? localStorage.getItem("token") : null;
    const response = await fetch(appendAuthToken(url), {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = `report-${id}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 1000);
  } catch (err) {
    openReportPdf(id, { download: true });
  }
};

export const openProductLabelsPdf = (id, { download = false } = {}) => {
  const url = getProductLabelsPdfUrl(id, download);

  if (typeof window === "undefined") {
    return;
  }

  if (download || isMobileDevice()) {
    window.location.assign(appendAuthToken(url));
    return;
  }

  const openedWindow = window.open(appendAuthToken(url), "_blank", "noopener,noreferrer");
  if (!openedWindow) {
    window.location.assign(appendAuthToken(url));
  }
};

export const downloadProductLabelsPdf = async (id) => {
  try {
    const url = getProductLabelsPdfUrl(id, true);
    const token = typeof localStorage !== "undefined" ? localStorage.getItem("token") : null;
    const response = await fetch(appendAuthToken(url), {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = `product-labels-${id}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 1000);
  } catch (err) {
    openProductLabelsPdf(id, { download: true });
  }
};

